// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"4cd905e6","453":"efb09825"}[chunkId] + ".chunk.js";
};